// extracted by mini-css-extract-plugin
module.exports = {"chip_categories":"Chip_chip_categories__LS5LL","chip_category":"Chip_chip_category__Ypjoe","chip_category_text":"Chip_chip_category_text__qZx7Z","active":"Chip_active__c5Xpt"};